const subscriptions = [{
  subscriptionType: "base",
  pricingModel: "perSeat",
  title: "Starter",
  price: 4.99,
  unit: "per seat/month",
  initialSeats: 1,
  maxSeats: 5,
  pricingLeafs: [{
    text: "AI agents (up to 5)"
  }, {
    text: "Premium AI models"
  }, {
    text: "API connections and tools for agents"
  }, {
    text: "Customer and Case Data Enrichment"
  }, {
    text: "Global language support (120+ languages)"
  }, {
    text: "Charts and Graphs Generation"
  }, {
    text: "Speech Recognition"
  }, {
    text: "Voice Synthesis"
  }, {
    text: "Centralised Knowledge hub (up to 100 docs)"
  }, {
    text: "1000 requests per user"
  }],
  ctaLabel: "Select plan",
  ctaRoute: "/contact-us",
  currency: "$"
}, {
  subscriptionType: "pro",
  pricingModel: "perSeat",
  title: "Pro",
  price: 14.99,
  unit: "per seat/month",
  initialSeats: 3,
  maxSeats: 20,
  pricingLeafs: [{
    text: "Everything in Starter..."
  }, {
    text: "AI agents (up to 15)"
  }, {
    text: "Autonomous Planner agents"
  }, {
    text: "Premium AI models"
  }, {
    text: "External Agents Widgets"
  }, {
    text: "AI Internet search"
  }, {
    text: "Images Generation"
  }, {
    text: "Python Code Execution"
  }, {
    text: "Personalised Voice Synthesis"
  }, {
    text: "Batch processing via CSV"
  }, {
    text: "Priority support"
  }, {
    text: "Centralised Knowledge hub (up to 500 docs)"
  }, {
    text: "5000 requests per user"
  }],
  ctaLabel: "Select plan",
  ctaRoute: "/contact-us",
  currency: "$"
}, {
  subscriptionType: "enterprise",
  pricingModel: "custom",
  title: "Enterprise",
  price: 0,
  unit: "per month",
  initialSeats: 30,
  maxSeats: 10000,
  pricingLeafs: [{
    text: "Everything in Pro..."
  }, {
    text: "Unlimited AI agents"
  }, {
    text: "Dedicated/On-Premise hosting"
  }, {
    text: "Single sign-on"
  }, {
    text: "Initial Hypercare & Dedicated Support"
  }, {
    text: "Full API access"
  }, {
    text: "Database connections for agents"
  }, {
    text: "Customisable Execution Environments"
  }, {
    text: "Fine-tuning pipelines"
  }, {
    text: "Teams & Slack integration"
  }, {
    text: "Custom integrations"
  }, {
    text: "Unlimited requests (excl. API)"
  }, {
    text: "Centralised Knowledge hub (unlimited docs)"
  }],
  ctaLabel: "Contact us",
  ctaRoute: "/contact-us",
  currency: "$"
}];

export { subscriptions as s };
